import { Popover } from 'foundations-components/transitional/components/Popover';
import H5 from 'UIComponents/elements/headings/H5';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerGroupActionDeleteButtonPopover = props => {
  const {
    children,
    onConfirm,
    onCancel,
    isOpen
  } = props;
  const onConfirmLocal = useCallback(event => {
    event.stopPropagation();
    onConfirm();
  }, [onConfirm]);
  const onCancelLocal = useCallback(event => {
    event.stopPropagation();
    onCancel();
  }, [onCancel]);
  return /*#__PURE__*/_jsx(Popover, {
    content: {
      header: /*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.filtersViewer.groupDeletePopoverHeader"
        })
      }),
      body: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.filtersViewer.groupDeletePopoverBody"
      }),
      footer: /*#__PURE__*/_jsxs(UIButtonWrapper, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "delete-group-confirm",
          onClick: onConfirmLocal,
          size: "sm",
          use: "danger",
          responsive: false,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "newCustomerDataFilters.filtersViewer.groupDeletePopoverConfirm"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: onCancelLocal,
          size: "sm",
          use: "tertiary-light",
          responsive: false,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "newCustomerDataFilters.filtersViewer.groupDeletePopoverCancel"
          })
        })]
      })
    },
    open: isOpen,
    placement: "right",
    inlineSize: "330px",
    children: children
  });
};
export default ViewerGroupActionDeleteButtonPopover;